var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.884857 9.00008C0.884857 4.79466 4.29402 1.3855 8.49944 1.3855C12.7049 1.3855 16.114 4.79466 16.114 9.00008C16.114 13.2055 12.7049 16.6147 8.49944 16.6147C4.29402 16.6147 0.884857 13.2055 0.884857 9.00008ZM9.38561 8.29175C9.38561 7.99835 9.14776 7.7605 8.85436 7.7605H7.43769C7.14429 7.7605 6.90644 7.99835 6.90644 8.29175C6.90644 8.58515 7.14429 8.823 7.43769 8.823H8.32311V12.5418C8.32311 12.8352 8.56096 13.073 8.85436 13.073C9.14776 13.073 9.38561 12.8352 9.38561 12.5418L9.38561 8.29175ZM9.38561 5.45841C9.38561 5.16501 9.14776 4.92716 8.85436 4.92716C8.56096 4.92716 8.32311 5.16501 8.32311 5.45841V6.16674C8.32311 6.46014 8.56096 6.69799 8.85436 6.69799C9.14776 6.69799 9.38561 6.46014 9.38561 6.16674V5.45841Z",
    fill: "#6FBE45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFilled);
export default __webpack_public_path__ + "static/media/info-filled.55445f09b59504eba0c4b857cd4f298c.svg";
export { ForwardRef as ReactComponent };